<!--广告情况修改-->
<template>
    <!--弹窗-->
    <el-dialog
        width="850px"
        title="FBA库存"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-table
            :row-key="getRowKeys"
            :data="list"
            class="table_content"
            size="mini"
            border
            height="400"
            style="width: 100%;">
            <el-table-column
                label="店铺"
                :resizable="false"
                prop="shopname"
                align="center">
            </el-table-column>
            <el-table-column
                label="msku"
                :resizable="false"
                prop="msku"
                align="center">
            </el-table-column>
            <el-table-column
                label="fnsku"
                :resizable="false"
                prop="fnsku"
                align="center">
            </el-table-column>
            <el-table-column label="在售|停售" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.status == 1 ? '在售' : '停售' }} <br/></div>
                </template>
            </el-table-column>
            <el-table-column
                label="可售"
                width="80"
                :resizable="false"
                prop="fba_sale_quantity"
                align="center">
            </el-table-column>
            <el-table-column
                label="在途"
                width="80"
                :resizable="false"
                prop="fba_transit_quantity"
                align="center">
            </el-table-column>
            <el-table-column
                label="是否在购物车"
                width="110"
                :resizable="false"
                align="center">
                <template slot-scope="scope">
                    <span :style="{color:scope.row.in_shopping === 1 ? 'green' : 'red'}">{{ scope.row.in_shopping === 1 ? '是' : '否' }}</span>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>
<script>

    export default {
        data() {
            return {
                visible: false,
                list: [],
                loading: false,
            }
        },
        methods: {
            getRowKeys(row) {
                return row.id
            },
            showModal(arr) {
                this.visible = true
                this.list = arr
            },
            // 关闭弹窗
            handleClose() {
                this.visible = false
                this.$emit('close-callback', {flag: false})
            },
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .content {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #cecfd1;
        font-size: 12px;
        color: #000;

        .shu {
            border-right: 1px solid #cecfd1;
        }

        .content-div {
            width: 50%;
            padding: 25px 20px;
        }

        .content-buttom {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #cecfd1;
            padding-bottom: 8px;
            margin-bottom: 10px;
        }

        .content-buttom-txet {
            color: rgb(57, 187, 252);
            cursor: pointer;
        }

        .content-data {
            width: 100%;
            height: 230px;
            overflow: auto;

            .content-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;

                .cha {
                    cursor: pointer;
                    font-size: 15px;
                    color: rgb(158, 192, 209);
                    margin: 0 10px 0 12px;
                }
            }
        }

        /deep/ .content-data::-webkit-scrollbar {
            width: 3px;
            height: 5px;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-track-piece {
            background-color: #ffff;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
            height: 5px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
            width: 3px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
    }

    .media-txt {
        font-size: 15px;
        color: #6a6c6f;
        font-weight: 600;
        margin-bottom: 8px;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 12px !important;
    }
</style>
